import { render, staticRenderFns } from "./ReceivePcn.vue?vue&type=template&id=47695c2a&scoped=true&"
import script from "./ReceivePcn.vue?vue&type=script&lang=js&"
export * from "./ReceivePcn.vue?vue&type=script&lang=js&"
import style0 from "./ReceivePcn.vue?vue&type=style&index=0&id=47695c2a&prod&lang=css&"
import style1 from "./ReceivePcn.vue?vue&type=style&index=1&id=47695c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47695c2a",
  null
  
)

export default component.exports